const Services = () => {
    return (
      <div className="py-16">
        <div className="container mx-auto px-4">
          {/* Services Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Our Services</h1>
            <div className="w-20 h-1 bg-primary mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We offer a comprehensive range of engineering and construction services
              tailored to meet your specific needs.
            </p>
          </div>
  
          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service cards will go here */}
          </div>
        </div>
      </div>
    );
  };
  
  export default Services;